export default __webpack_public_path__ + "static/media/project-three-img.fb7dd341.svg";